// extracted by mini-css-extract-plugin
export default {"btop":"e50226da1f a80747cb47 feb366913f","icon":"f6ca888a98 _383bc64857","btoppink":"d2043833e0 _20cfefae2b"};